export default __webpack_public_path__ + "locales/lv/InviteDialog.json?hash=eea6ef9a32695f7df22cf9916795f510";